import jQuery from 'jquery';
import ModalVideo from 'modal-video';

jQuery(function ($) {
  $('body').removeClass('no-js');

  //init youtube modales
  new ModalVideo('.js-modal-btn', {
    youtube: {
      autoplay: 1,
      nocookie: 'true',
    },
  });

  // Helper function to update raison select field and scroll
  function handleRaisonParameter(hash) {
    const match = hash.match(/#contact\?raison=([^&]+)/);

    if (match && match[1]) {
      const raisonValue = match[1];

      // Map raison values to their corresponding select option values
      const optionMap = {
        devis: 'Demande de devis',
        activite: "Réservation d'une activité",
        goodies: 'Acheter un souvenir',
      };

      const optionText = optionMap[raisonValue];

      if (optionText) {
        // Find the select field and update its value
        $('select[name="raison"]')
          .find(`option:contains("${optionText}")`)
          .prop('selected', true);

        // Trigger change event to ensure any listeners are notified
        $('select[name="raison"]').change();
      }

      // Handle activite parameter if raison is "activite"
      if (raisonValue === 'activite') {
        const activiteMatch = hash.match(/activite=([^&]+)/);
        if (activiteMatch && activiteMatch[1]) {
          const activiteValue = decodeURIComponent(activiteMatch[1]);

          // Map activite values to their corresponding select option values
          const activiteOptionMap = {
            'biathlon-basket': 'Biathlon en basket',
            'biathlon-ski-roue': 'Biathlon à ski roue',
            'ski-roue': 'Ski roue',
            challenge: 'Challenge biathlon Famille et Amis',
          };

          const activiteOptionText = activiteOptionMap[activiteValue];

          if (activiteOptionText) {
            // Find the select field and update its value
            $('select[name="activite"]')
              .find(`option:contains("${activiteOptionText}")`)
              .prop('selected', true);

            // Trigger change event to ensure any listeners are notified
            $('select[name="activite"]').change();
          }
        }
      }

      // Scroll to contact element
      const contactElement = $('#contact');
      if (contactElement.length) {
        $('html, body').animate(
          {
            scrollTop: contactElement.offset().top,
          },
          500,
        );
      }
    }
  }

  // Check for raison parameter on page load
  if (window.location.hash) {
    handleRaisonParameter(window.location.hash);
  }

  // Handle anchor clicks with raison parameter
  $(document).on('click', 'a[href*="#contact?raison="]', function (e) {
    e.preventDefault();
    const href = $(this).attr('href');
    handleRaisonParameter(href);
  });
});
